// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__bCIwj","spinner":"loading_spinner__YweYZ","Shimiring":"loading_Shimiring__KswkO"};